import {
  SAVE_VALIDATE_DATA_BEGIN,
  SAVE_VALIDATE_DATA_SUCCESS,
  SAVE_VALIDATE_DATA_SUCCESS_AND_GO_NEXT,
  SAVE_VALIDATE_DATA_FAILURE,
} from './constants';
import { cloneDeep } from "lodash";
import { BFFAgent } from '../../../common/BFFAgent';
import { translateStockTerm } from './utils';

const translateStockToProcess = (stockToProcess, schema, translatorStepKey, inconsistency, translationItem) => {
  stockToProcess.forEach(stock => {
    translateStockTerm(stock, translatorStepKey, inconsistency, schema, translationItem)
  })
}

export function saveValidateDataStep({
  translatorStepKey,
  inconsistencies,
  schema,
  stockToProcess,
  goToNext = false
}) {
  return async dispatch => {
    dispatch({
      type: SAVE_VALIDATE_DATA_BEGIN
    })

    try {
      let stockToProcessClone = cloneDeep(stockToProcess)
      for (let inconsistency of inconsistencies) {
        if(inconsistency.translation && !inconsistency.saveValidateDataSuccess) {
          const metadata = {}
          schema[translatorStepKey].metadata?.forEach(
            metadataKey => metadata[metadataKey] = inconsistency[metadataKey]
          )
          const translationItem = inconsistency.values?.find(
            (value) => value.id === inconsistency.translation
          )
          translateStockToProcess(stockToProcessClone, schema, translatorStepKey, inconsistency, translationItem)
          
          const dictionary = {
            schema: translatorStepKey,
            metadata,
            word: inconsistency[translatorStepKey],
            translation: inconsistency.translation,
            isValid: true
          }

          await BFFAgent.Stock.saveValidateData(dictionary)
          inconsistency.saveValidateDataSuccess = true;

        } else if(inconsistency.translation === null && goToNext) {
          translateStockToProcess(stockToProcessClone, schema, translatorStepKey, inconsistency, null)
        } 
      }
      if (goToNext) {
        dispatch({
          type: SAVE_VALIDATE_DATA_SUCCESS_AND_GO_NEXT,
          data: { stockToProcessClone },
        })
      } else {
        dispatch({
          type: SAVE_VALIDATE_DATA_SUCCESS,
          data: { stockToProcessClone, inconsistencies },
        })
      } 
    } catch (err) {
      dispatch({
        type: SAVE_VALIDATE_DATA_FAILURE,
        data: { error: err }
      })
    }
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case SAVE_VALIDATE_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        saveValidateDataPending: true,
        saveValidateDataError: null,
        saveValidateDataSuccess: false
      }

    case SAVE_VALIDATE_DATA_SUCCESS:

      return {
        ...state,
        stockToProcess: action.data.stockToProcessClone,
        saveValidateDataPending: false,
        saveValidateDataError: null,
        saveValidateDataSuccess: true,
        messageRouteLeaving: "No terminaste la carga. ¿Querés salir igual?",
        translator: {
          ...state.translator,
          [state.translatorStepKey]: {
            ...state.translator[[state.translatorStepKey]],
            inconsistencies: action.data.inconsistencies
          }
        },
      }
    case SAVE_VALIDATE_DATA_SUCCESS_AND_GO_NEXT:
      let newTranslatorStep;
      let newTranslatorStepKey;
      const nextStepOrder = state.translatorStep + 1
      let completedStepper = false;
      for (let schemaKey in state.schema) {
        const currentStep = state.schema[schemaKey]
        if (currentStep.order === nextStepOrder && currentStep.requiresValidation) {
          newTranslatorStepKey = schemaKey
          newTranslatorStep = nextStepOrder
          break
        }
        if (currentStep.order + 1 === state.translatorSteps.length){
          completedStepper = true;
        }
      }
      return {
        ...state,
        stockToProcess: action.data.stockToProcessClone,
        saveValidateDataPending: false,
        saveValidateDataError: null,
        translatorStep: newTranslatorStep ? newTranslatorStep : state.translatorStep,
        lastTranslationStep: newTranslatorStep ? newTranslatorStep : state.translatorStep,
        translatorStepKey: newTranslatorStepKey ? newTranslatorStepKey : state.translatorStepKey,
        translator: {
          ...state.translator,
          [state.translatorStepKey]: {
            ...state.translator[[state.translatorStepKey]],
            completed: true
          }
        },
        completedStepper
      }

    case SAVE_VALIDATE_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        saveValidateDataPending: false,
        saveValidateDataError: action.data.error
      }

    default:
      return state
  }
}
